// extracted by mini-css-extract-plugin
module.exports = {"clickable":"CwSTCg"};